import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { CustomTitleOptions } from './custom-title.interface';
import { FieldConfig } from '../dynamic-form/dynamicForm.interface';
import { FormGroup } from '@angular/forms';


@Component({
    selector: 'app-custom-title',
    templateUrl: './custom-title.component.html',
    styleUrls: ['./custom-title.component.scss'],
    standalone: false
})
export class CustomTitleComponent implements OnInit, OnChanges{

  @Input() options: CustomTitleOptions | undefined;
  @Input() field: FieldConfig | undefined;
  @Input() group: FormGroup | undefined;

  parsedOptions: CustomTitleOptions | undefined;


  constructor() {

  }

  ngOnInit(): void {
    
  }

  ngOnChanges(change: {options: SimpleChange}): void {
    
  }

}
